<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/6hfReP/tc-custom/9781035867455.jpg?1725723409006" alt="This image is the cover for the book The Roadside Fairies – Book 2"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The Roadside Fairies – Book 2
      </h1>
      <p class="bookDescription body article font2">
        <p>Living along side of us for many years, the Roadside Fairy dwellings are always situated close by roads, motorways and paths, hidden from sight using their magic to stay secret. Their main role is assisting, protecting and healing the creatures of the lands great and small. All of the Roadside Fairies have to be rejuvenated to prolong their life and magical abilities, this is done by using spells and incantations from the sacred book of The Elders. Rejuvenation ceremonies always take place at special times of the year, they understand the astral and lunar powers that intensify the magic they use. A Great Elder Simone who lives in Australia is travelling to the Greenwood dwelling for her 100-year rejuvenation ceremony, a cause for great celebration where Roadside Fairies will travel from all parts of the world to be present. Dark energy begins to flow with the creatures of Greenwood Forest feeling unnerved, are their friends in danger?</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Jacqueline Derbyshire
      </h2>
      
      <p class="authorDescription body article">Jacqueline Derbyshire was born and raised in Wallasey Merseyside. She has worked all of her life working predominantly in health and social care. Now a big decision in her life is to concentrate on her books, her joy: the Roadside Fairies series. Jacqueline has written six books so far in the series, this being book two. Working with local people, James Connolly, an artist who has done the illustrations and Lee Pennington, a composer and singer with the support of Dan Astles who have created the music for Clover’s song written by Jacqueline. Together they are excited to share this book offering the reader a journey into the realms of magic, mystical creatures and secrets.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Austin Macauley
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?33337106